/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the BeaconAuth community`)
};

const zh_hans1_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 BeaconAuth 社区`)
};

const zh_hant1_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 BeaconAuth 社群`)
};

const fr_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez la communauté BeaconAuth`)
};

const de_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tritt der BeaconAuth-Community bei`)
};

const ja_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BeaconAuth コミュニティに参加`)
};

const ko_register_description_join_community = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BeaconAuth 커뮤니티에 참여하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_description_join_community = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_description_join_community(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_description_join_community", locale)
	if (locale === "en") return en_register_description_join_community(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_description_join_community(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_description_join_community(inputs)
	if (locale === "fr") return fr_register_description_join_community(inputs)
	if (locale === "de") return de_register_description_join_community(inputs)
	if (locale === "ja") return ja_register_description_join_community(inputs)
	return ko_register_description_join_community(inputs)
};